import React from 'react';
import { Box, Typography, Grid, Card, CardContent } from '@mui/material';
import { StatistikyReakce, formatujDobuReakce } from '../utils/statistikyUtils';

interface StatistikyReakceCardProps {
    statistiky: StatistikyReakce | null;
}

const StatistikyReakceCard: React.FC<StatistikyReakceCardProps> = ({ statistiky }) => {
    if (!statistiky) return null;

    return (
        <Box>
            {/* Doba reakce */}
            <Grid container spacing={2} sx={{ mb: 2 }}>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Card sx={{ bgcolor: 'primary.light', height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', py: 2, px: 1 }}>
                            <Typography variant="h5" color="primary.dark">
                                {formatujDobuReakce(statistiky.prumernaDobaReakce)}
                            </Typography>
                            <Typography variant="caption" color="primary.dark">
                                Průměr
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Card sx={{ bgcolor: 'info.light', height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', py: 2, px: 1 }}>
                            <Typography variant="h5" color="info.dark">
                                {formatujDobuReakce(statistiky.medianDobaReakce)}
                            </Typography>
                            <Typography variant="caption" color="info.dark">
                                Medián
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Card sx={{ bgcolor: 'success.light', height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', py: 2, px: 1 }}>
                            <Typography variant="h5" color="success.dark">
                                {formatujDobuReakce(statistiky.minDobaReakce)}
                            </Typography>
                            <Typography variant="caption" color="success.dark">
                                Min
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid size={{ xs: 6, sm: 3 }}>
                    <Card sx={{ bgcolor: 'warning.light', height: '100%' }}>
                        <CardContent sx={{ textAlign: 'center', py: 2, px: 1 }}>
                            <Typography variant="h5" color="warning.dark">
                                {formatujDobuReakce(statistiky.maxDobaReakce)}
                            </Typography>
                            <Typography variant="caption" color="warning.dark">
                                Max
                            </Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {/* Funkce */}
            <Box display="flex" flexWrap="wrap" gap={1} justifyContent="center">
                {[
                    { label: 'Velitel družstva', count: statistiky.pocetVD },
                    { label: 'Strojník', count: statistiky.pocetS },
                    { label: 'Hasič', count: statistiky.pocetH }
                ].map((item) => (
                    <Box
                        key={item.label}
                        sx={{
                            minWidth: 140,
                            height: 40,
                            borderRadius: 2,
                            backgroundColor: 'grey.100',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            px: 2,
                            border: 1,
                            borderColor: 'grey.300',
                            boxShadow: 1,
                        }}
                    >
                        <Typography fontWeight="bold" fontSize={14}>
                            {item.label}:
                        </Typography>
                        <Typography fontWeight="bold" fontSize={24} color="primary.main">
                            {item.count}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default StatistikyReakceCard;
